<template>
  <Head>
    <title>{{ meta.title }}</title>
    <meta name="description" :content="meta.description">
    <meta name="keywords" :content="meta.keywords">
    
    <!-- Open Graph / Facebook -->
    <meta property="og:type" content="website">
    <meta property="og:url" :content="currentUrl">
    <meta property="og:title" :content="meta.ogTitle || meta.title">
    <meta property="og:description" :content="meta.ogDescription || meta.description">
    <meta property="og:image" :content="meta.ogImage" v-if="meta.ogImage">
    
    <!-- Twitter -->
    <meta name="twitter:card" content="summary_large_image">
    <meta name="twitter:url" :content="currentUrl">
    <meta name="twitter:title" :content="meta.twitterTitle || meta.title">
    <meta name="twitter:description" :content="meta.twitterDescription || meta.description">
    <meta name="twitter:image" :content="meta.twitterImage || meta.ogImage" v-if="meta.twitterImage || meta.ogImage">
    
    <!-- Additional custom meta tags -->
    <slot></slot>
  </Head>
</template>

<script setup>
import { Head } from '@inertiajs/vue3';
import { computed } from 'vue';
import { isBrowser } from '@/utils/ssr-helpers';

const props = defineProps({
  meta: {
    type: Object,
    required: true
  }
});

// Use meta.url from server if available, otherwise fallback to window.location.href in browser
const currentUrl = computed(() => {
  // If the server provided a URL, use it
  if (props.meta.url) {
    return props.meta.url;
  }
  
  // Otherwise, safely access window.location.href in browser
  return isBrowser() ? window.location.href : '';
});
</script>
